import { render, staticRenderFns } from "./ProductDetails.vue?vue&type=template&id=48e133de&scoped=true"
import script from "./ProductDetails.vue?vue&type=script&lang=js"
export * from "./ProductDetails.vue?vue&type=script&lang=js"
import style0 from "./ProductDetails.vue?vue&type=style&index=0&id=48e133de&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e133de",
  null
  
)

export default component.exports